import GraphData from '../graphData';

/**
 * Create the action
 */

const { thunk, request, success, error } = GraphData.index((fetch) =>
    fetch.get(`/graph-data`)
);

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
